import { render, staticRenderFns } from "./AfterSalesPickupPage.vue?vue&type=template&id=3a37c62a&scoped=true"
import script from "./AfterSalesPickupPage.vue?vue&type=script&lang=js"
export * from "./AfterSalesPickupPage.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesPickupPage.vue?vue&type=style&index=0&id=3a37c62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37c62a",
  null
  
)

export default component.exports